import getCurrencySymbol from '../utilities/currency/getCurrencySymbol'
export const SET_ACTIVE_CURRENCY = 'SET_ACTIVE_CURRENCY'

export const updateCurrency = activeCurrency => ({
	type: SET_ACTIVE_CURRENCY,
	payload: activeCurrency
})

export default function setActiveCurrency(activeCurrency) {
	return (dispatch, getState) => {

		let activeExchangeRate = null
		const exchangeRates = getState().exchangeRatesData.exchangeRates

		// Filter openExchange rates for current set currency code
		for (let exchangeKey in exchangeRates) {
			if (exchangeKey === activeCurrency) {
				activeExchangeRate = exchangeRates[exchangeKey]
			}
		}

		let activeCurrencyData = {
			currencyCode: activeCurrency,
			currencySymbol: getCurrencySymbol(activeCurrency),
			exchangeRate: activeExchangeRate
		}

		dispatch(updateCurrency(activeCurrencyData))
	}
}



// WEBPACK FOOTER //
// ./src/actions/setActiveCurrency.js